    // Global script for White Glove Service automation
    (function () {
      const PREMIUM_SERVICE_HANDLE = 'smart-ease-cushion-app-remote-monitoring';
      const CUSHION_HANDLES = ['ease-cushion', 'ease-cushion-gen-2'];
      let isProcessing = false;
      let lastCartState = null;

      // Shared, rate-limited cart fetcher (coalesces calls across scripts)
      if (!window.__sharedCartFetch) {
        var _promise = null, _ts = 0;
        window.__sharedCartFetch = function() {
          var now = Date.now();
          if (_promise && now - _ts < 3000) return _promise;
          _ts = now;
          _promise = fetch('/cart.js')
            .then(function(r) { return r.ok ? r.json() : null; })
            .catch(function() { return null; });
          return _promise;
        };
      }

      function fetchCartSafe() {
        return window.__sharedCartFetch();
      }

      // Function to get premium service variant ID
      async function getPremiumServiceVariantId() {
        try {
          const response = await fetch(`/products/${PREMIUM_SERVICE_HANDLE}.js`);
          if (!response.ok) return null;
          const product = await response.json();
          return product.variants[0].id;
        } catch (err) {
          console.error('Error getting premium service variant:', err);
          return null;
        }
      }

      // Function to check if cart has cushions
      function hasCushionInCart(cart) {
        return cart.items.some((item) => CUSHION_HANDLES.includes(item.handle));
      }

      // Function to check if cart has premium service
      function hasPremiumServiceInCart(cart) {
        return cart.items.some((item) => item.handle === PREMIUM_SERVICE_HANDLE);
      }

      // Function to get premium service line item key
      function getPremiumServiceKey(cart) {
        const item = cart.items.find((item) => item.handle === PREMIUM_SERVICE_HANDLE);
        return item ? item.key : null;
      }

      // Function to add premium service to cart
      async function addPremiumService() {
        if (isProcessing) return;
        isProcessing = true;

        try {
          const variantId = await getPremiumServiceVariantId();
          if (!variantId) {
            isProcessing = false;
            return;
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                },
              ],
            }),
          });

          if (response.ok) {
            console.log('White Glove Service added successfully');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        } catch (err) {
          console.error('Error adding premium service:', err);
        } finally {
          isProcessing = false;
        }
      }

      // Function to remove premium service from cart
      async function removePremiumService(cart) {
        if (isProcessing) return;
        isProcessing = true;

        try {
          const serviceKey = getPremiumServiceKey(cart);
          if (!serviceKey) {
            isProcessing = false;
            return;
          }

          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: serviceKey,
              quantity: 0,
            }),
          });

          if (response.ok) {
            console.log('White Glove Service removed successfully');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        } catch (err) {
          console.error('Error removing premium service:', err);
        } finally {
          isProcessing = false;
        }
      }

      // Main function to manage white glove service
      async function manageWhiteGloveService(cartData) {
        if (isProcessing) return;

        try {
          const cart = cartData || await fetchCartSafe();
          if (!cart) return;

          const hasCushion = hasCushionInCart(cart);
          const hasService = hasPremiumServiceInCart(cart);

          const currentCartState = JSON.stringify({ hasCushion, hasService, itemCount: cart.item_count });
          if (currentCartState === lastCartState) {
            return;
          }
          lastCartState = currentCartState;

          if (hasCushion && !hasService) {
            await addPremiumService();
          } else if (!hasCushion && hasService) {
            await removePremiumService(cart);
          }
        } catch (err) {
          console.error('Error managing white glove service:', err);
        }
      }

      // Function to prevent checkout if only premium service in cart
      async function preventCheckoutIfOnlyService(cartData) {
        try {
          const cart = cartData || await fetchCartSafe();
          if (!cart) return;

          const hasService = hasPremiumServiceInCart(cart);
          const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);

          if (hasService && !hasOtherProducts) {
            const checkoutButtons = document.querySelectorAll(
              '[name="checkout"], .cart__checkout-button, button[type="submit"][name="checkout"], [href*="/checkout"]'
            );
            checkoutButtons.forEach((btn) => {
              btn.disabled = true;
              btn.style.opacity = '0.5';
              btn.style.cursor = 'not-allowed';
              btn.title = 'The App cannot be purchased alone. Please add a cushion to your cart.';
              if (btn.tagName === 'A') {
                btn.dataset.originalHref = btn.href;
                btn.removeAttribute('href');
              }
            });
          } else {
            const checkoutButtons = document.querySelectorAll(
              '[name="checkout"], .cart__checkout-button, button[type="submit"][name="checkout"], [data-original-href]'
            );
            checkoutButtons.forEach((btn) => {
              btn.disabled = false;
              btn.style.opacity = '1';
              btn.style.cursor = 'pointer';
              btn.title = '';
              if (btn.dataset.originalHref) {
                btn.href = btn.dataset.originalHref;
                delete btn.dataset.originalHref;
              }
            });
          }
        } catch (err) {
          console.error('Error checking cart for checkout:', err);
        }
      }

      // Debounce: collapse rapid-fire events into a single check
      let pendingTimer = null;
      function scheduleCartCheck(cartData) {
        clearTimeout(pendingTimer);
        pendingTimer = setTimeout(() => {
          manageWhiteGloveService(cartData);
          preventCheckoutIfOnlyService(cartData);
        }, 800);
      }

      // Block form submissions when only service in cart
      document.addEventListener('submit', async function(e) {
        const form = e.target;
        if (form.action && (form.action.includes('/checkout') || form.action.includes('/cart'))) {
          const cart = await fetchCartSafe();
          if (cart) {
            const hasService = hasPremiumServiceInCart(cart);
            const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
            if (hasService && !hasOtherProducts) {
              e.preventDefault();
              e.stopPropagation();
              alert('The App cannot be purchased alone. Please add a cushion to your cart first.');
              return false;
            }
          }
        }
      }, true);

      // Block direct navigation to checkout
      document.addEventListener('click', async function(e) {
        const link = e.target.closest('a[href*="/checkout"]');
        if (link) {
          const cart = await fetchCartSafe();
          if (cart) {
            const hasService = hasPremiumServiceInCart(cart);
            const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
            if (hasService && !hasOtherProducts) {
              e.preventDefault();
              e.stopPropagation();
              alert('The App cannot be purchased alone. Please add a cushion to your cart first.');
              return false;
            }
          }
        }
      }, true);

      // Block checkout page access
      if (window.location.pathname.includes('/checkout')) {
        fetchCartSafe().then((cart) => {
          if (!cart) return;
          const hasService = hasPremiumServiceInCart(cart);
          const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
          if (hasService && !hasOtherProducts) {
            alert('The App cannot be purchased alone. Please add a cushion to your cart first.');
            window.location.href = '/cart';
          }
        });
      }

      // Reuse cart data from events when available to avoid extra /cart.js calls
      document.addEventListener('cart:change', (e) => {
        const cart = e.detail && e.detail.cart;
        scheduleCartCheck(cart && cart.items ? cart : null);
      });

      document.addEventListener('cart:refresh', () => {
        scheduleCartCheck(null);
      });

      document.addEventListener('submit', function (e) {
        if (e.target.matches('form[action*="/cart/add"]') || e.target.matches('product-form')) {
          setTimeout(() => scheduleCartCheck(null), 1000);
        }
      });

      // Initial check on page load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => scheduleCartCheck(null), 1000);
        });
      } else {
        setTimeout(() => scheduleCartCheck(null), 1000);
      }

      // Polling reduced to every 10 seconds with a single combined fetch
      setInterval(() => scheduleCartCheck(null), 10000);
    })();
